import { useTranslation } from "react-i18next";
import { PLATFORM } from "@/data/platform";

// Fuelly logo — the round gradient mark used across the app.
export const FuellyLogo = ({ size = 20, className = "" }) => (
  <img
    src={PLATFORM.logo}
    alt="Fuelly"
    width={size}
    height={size}
    className={`object-contain ${className}`}
    style={{ width: size, height: size }}
  />
);

// Small "Powered by Fuelly" strip — used in screen footers.
export const FuellyBadge = ({ variant = "light", className = "" }) => {
  const { t } = useTranslation();
  const isDark = variant === "dark";
  return (
    <div
      data-testid="fuelly-badge"
      className={`inline-flex items-center gap-2 ${className}`}
    >
      <span className={`text-[10px] font-mono uppercase tracking-[0.3em] ${isDark ? "text-white/50" : "text-neutral-400"}`}>
        {t("brand.poweredBy")}
      </span>
      <FuellyLogo size={16} />
      <span className={`text-sm font-bold tracking-tight ${isDark ? "text-white" : "text-neutral-900"}`}>
        {PLATFORM.name}
      </span>
    </div>
  );
};

// Larger brand lockup — for profile top corner and marketing moments.
export const FuellyLockup = ({ size = 22, className = "" }) => (
  <div
    data-testid="fuelly-lockup"
    className={`inline-flex items-center gap-1.5 ${className}`}
  >
    <FuellyLogo size={size} />
    <span
      className="font-bold tracking-tight text-neutral-900"
      style={{ fontSize: Math.round(size * 0.75) }}
    >
      {PLATFORM.name}
    </span>
  </div>
);

export default FuellyLogo;
